var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-table-card',{scopedSlots:_vm._u([{key:"item.dtaLiquidacao",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDatePattern(_vm.itemdtaLiquidacao, 'DD/MM/YYYY'))+" ")]}},{key:"item.valor",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getMoney(item.valor))+" ")]}}])},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$tc('title.pagamentos_liquidados')))])]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.liquidados,"options":_vm.pagination,"server-items-length":_vm.totalPaginas,"footer-props":{
          itemsPerPageOptions: [5, 10, 25, 50],
        },"no-data-text":_vm.$t('label.tabela_sem_conteudo')},on:{"update:options":function($event){_vm.pagination=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/custom/abbrasil/spa/dashboard/cadeia/acompanhamento/PagamentosLiquidadosTabela.vue?vue&type=template&id=0ee9ac09&lang=html&
// module id = 1284
// module chunks = 28